import { render, staticRenderFns } from "./WorkPermitTable.vue?vue&type=template&id=6d1f06f3&scoped=true&"
import script from "./WorkPermitTable.vue?vue&type=script&lang=js&"
export * from "./WorkPermitTable.vue?vue&type=script&lang=js&"
import style0 from "./WorkPermitTable.vue?vue&type=style&index=0&id=6d1f06f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1f06f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d1f06f3')) {
      api.createRecord('6d1f06f3', component.options)
    } else {
      api.reload('6d1f06f3', component.options)
    }
    module.hot.accept("./WorkPermitTable.vue?vue&type=template&id=6d1f06f3&scoped=true&", function () {
      api.rerender('6d1f06f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/dashboards/WorkPermitTable.vue"
export default component.exports